import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { TiArrowBack } from "react-icons/ti";
import './TopBar.css';

const TopBar = ({ currentPage, isLoggedIn, onLogout, showBackButton = false, onBack }) => {
  const { user } = useAuth();

  const getTitle = () => {
    switch (currentPage) {
      case 'home': return 'Café Motezuma';
      case 'menu': return 'Menu';
      case 'store': return 'Tiendas';
      case 'cards': return 'Tarjetas';
      case 'checkout': return 'Tiempo de espera';
      default: return 'Café Motezuma';
    }
  };

  const getTime = () => {
    return new Date().toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  return (
    <div className="top-bar">
      <div className="top-bar-left">
        {showBackButton ? (
          <button className="back-button" onClick={onBack}>
            <TiArrowBack />
          </button>
        ) : (
          <span className="current-time">{getTime()}</span>
        )}
      </div>

      <div className="top-bar-center">
        <h1 className="page-title">{getTitle()}</h1>
      </div>

      <div className="top-bar-right">
        {isLoggedIn ? (
          <div className="user-info">
            <div className="user-avatar">
              {user?.name?.split(' ').map(n => n[0]).join('') || 'Dante Moss'}
            </div>
            {!showBackButton && (
              <button className="logout-btn-small" onClick={onLogout}>
                Logout
              </button>
            )}
          </div>
        ) : (
          <div className="login-indicator">Sesión No iniciada</div>
        )}
      </div>
    </div>
  );
};

export default TopBar;